import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { MemberManagementFormFragmentDoc } from '../../../components/organisms/MemberManagementForm/MemberManagemenetForm.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SettingsPageMemberManagementCreateViewQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SettingsPageMemberManagementCreateViewQuery = { __typename?: 'Query', teams: Array<{ __typename?: 'Team', guid: string, name: string }> };

export type CreateStaffMutationVariables = Types.Exact<{
  input: Types.CreateStaffInput;
}>;


export type CreateStaffMutation = { __typename?: 'Mutation', createStaff: { __typename: 'CreateStaffErrorAlreadyExistsPayload' } | { __typename: 'CreateStaffSuccessPayload' } };


export const SettingsPageMemberManagementCreateViewDocument = gql`
    query SettingsPageMemberManagementCreateView {
  ...MemberManagementForm
}
    ${MemberManagementFormFragmentDoc}`;

/**
 * __useSettingsPageMemberManagementCreateViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageMemberManagementCreateViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageMemberManagementCreateViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageMemberManagementCreateViewQuery();
 */
export function useSettingsPageMemberManagementCreateViewQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementCreateViewQuery, SettingsPageMemberManagementCreateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementCreateViewQuery, SettingsPageMemberManagementCreateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementCreateViewQuery, SettingsPageMemberManagementCreateViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageMemberManagementCreateViewQuery, SettingsPageMemberManagementCreateViewQueryVariables>(SettingsPageMemberManagementCreateViewDocument, {}, options);
}
export function useSettingsPageMemberManagementCreateViewLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementCreateViewQuery, SettingsPageMemberManagementCreateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementCreateViewQuery, SettingsPageMemberManagementCreateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementCreateViewQuery, SettingsPageMemberManagementCreateViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageMemberManagementCreateViewQuery, SettingsPageMemberManagementCreateViewQueryVariables>(SettingsPageMemberManagementCreateViewDocument, {}, options);
}
export type SettingsPageMemberManagementCreateViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageMemberManagementCreateViewQuery, SettingsPageMemberManagementCreateViewQueryVariables>;
export const CreateStaffDocument = gql`
    mutation createStaff($input: CreateStaffInput!) {
  createStaff(input: $input) {
    __typename
  }
}
    `;

/**
 * __useCreateStaffMutation__
 *
 * To run a mutation, you first call `useCreateStaffMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateStaffMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateStaffMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateStaffMutation(options: VueApolloComposable.UseMutationOptions<CreateStaffMutation, CreateStaffMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateStaffMutation, CreateStaffMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateStaffMutation, CreateStaffMutationVariables>(CreateStaffDocument, options);
}
export type CreateStaffMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateStaffMutation, CreateStaffMutationVariables>;